import { makeStyles } from '@material-ui/core';

import { useScreen } from '@/hooks/useScreen';
import { DefaultTableColumn } from '@/types/defaultTableColumn';

export const usePaymentAttemptsTable = () => {
  const { isMobile } = useScreen();

  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
  });

  const classes = useStyles();

  const columnsDesktop: DefaultTableColumn[] = [
    { name: 'status', label: 'PAYMENT_ATTEMPT_STATUS', align: 'left', colWidth: '25%' },
    { name: 'failReason', label: 'PAYMENT_ATTEMPT_FAIL_REASON', align: 'left', colWidth: '40%' },
    { name: 'createdAt', label: 'PAYMENT_ATTEMPT_CREATED_AT', align: 'right', colWidth: '35%' },
  ];

  const columnsMobile: DefaultTableColumn[] = [
    { name: 'status', label: 'PAYMENT_ATTEMPT_STATUS', align: 'left', colWidth: '35%' },
    { name: 'createdAt', label: 'PAYMENT_ATTEMPT_CREATED_AT', align: 'right', colWidth: '65%' },
  ];

  const columns = isMobile ? columnsMobile : columnsDesktop;

  return { classes, columns };
};
